/** IANA timezone autocomplete (local list via Intl — no network). */
import { Autocomplete, TextField } from '@mui/material';
import { useMemo } from 'react';

/** Every IANA zone the browser knows (a short fallback list where it cannot say). */
export function timezoneOptions(): string[] {
  try {
    const supported = (Intl as unknown as { supportedValuesOf?: (k: string) => string[] }).supportedValuesOf;
    if (typeof supported === 'function') return supported('timeZone');
  } catch {
    /* fall through */
  }
  return ['UTC', 'Europe/London', 'Europe/Reykjavik', 'America/New_York', 'America/Los_Angeles'];
}

export function TimezonePicker({
  value, onChange, label = 'Timezone', size = 'small', disabled,
}: {
  value: string | null;
  onChange: (tz: string | null) => void;
  label?: string;
  size?: 'small' | 'medium';
  disabled?: boolean;
}) {
  const options = useMemo(timezoneOptions, []);
  return (
    <Autocomplete
      size={size}
      disabled={disabled}
      options={options}
      value={value}
      onChange={(_, v) => onChange(v)}
      autoHighlight
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder="Europe/Reykjavik" />
      )}
    />
  );
}
